<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-18 13:38:37
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-07-15 18:32:21
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/src/case-4/components/AddTreatment/index.vue
-->
<template>
    <!-- 新增编辑检验项目 -->
    <el-dialog :title="title" center :visible.sync="dialogVisible" width="683px" :height='height'
        :close-on-click-modal='false' :destroy-on-close="true" @close="closeModule">
        <el-form ref="form" :model="formData" :rules="rules" label-width="170px" size='small'>

            <el-form-item label="治疗项目名称：" prop='name'>
                <el-input v-model="formData.name" placeholder="请输入治疗项目名称" clearable>
                </el-input>
            </el-form-item>

            <el-form-item label="治疗项目代码：" prop='code'>
                <el-input v-model.number="formData.code" placeholder="请输入治疗项目代码" @input="inputChange" clearable>
                </el-input>
            </el-form-item>

            <el-form-item label="治疗一级类目：" prop='type1'>
                <el-select @change="type1Change" v-model="formData.type1" placeholder="请选择治疗一级类目">
                    <el-option v-for="item in type1List" :key="item.id" :label="item.categoryName" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="治疗二级类目：" prop='type2'>
                <el-select @change="type2Change" v-model="formData.type2" placeholder="请选择治疗二级类目">
                    <el-option v-for="item in type2List" :key="item.id" :label="item.categoryName" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="治疗三级类目：" prop='type3'>
                <el-select v-model="formData.type3" placeholder="请选择治疗三级类目">
                    <el-option v-for="item in type3List" :key="item.id" :label="item.categoryName" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否启用：">
                <el-radio-group v-model="formData.enabled">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="备注：" style="margin-bottom:30px">
                <el-input type="textarea" resize='none' v-model="formData.remark" placeholder="请输入您要备注的内容" clearable>
                </el-input>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button style="width:110px;" size="small" @click="resetHandel">重置</el-button>
            <el-button type="primary" size="small" @click="onSubmit" style="width:110px;">保存</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { list, addTreatment, putTreatment } from '../../api'
export default {
    props: {
        //TODO编辑参数
        formDataValue: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            height: '80vh',
            isEdit: false,//fasle为新增 true修改
            dialogVisible: false,//弹窗
            title: "新增治疗项目",//标题
            formData: {
                id: '',
                name: '',//名称
                code: '',//代码
                type1: '',//一级类目
                type2: '',//二级类目
                type3: '',//三级类目
                enabled: true,//是否启用 1 是 0 否
                remark: '',//备注
            },
            listQuery: {
                status: false,
                type: 4,
                parentId: 0
            },
            type1List: [],
            type2List: [],
            type3List: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入治疗项目名称',
                        trigger: 'blur'
                    },
                ],
                code: [
                    {
                        required: true,
                        message: '请输入治疗项目编码',
                        trigger: 'blur'
                    },
                    { pattern: /^[A-Za-z0-9]+$/, message: '只能输入字母、数字', trigger: ['change', 'blur'] }
                ],
                type1: [
                    {
                        required: true,
                        message: '请选择治疗一级类目',
                        trigger: 'change'
                    }
                ],
                type2: [
                    {
                        required: true,
                        message: '请选择治疗二级类目',
                        trigger: 'change'
                    }
                ],
                type3: [
                    {
                        required: true,
                        message: '请选择治疗三级类目',
                        trigger: 'change'
                    }
                ],
            },
        }
    },
    watch: {
        formDataValue: {
            handler(newVal) {
                Object.keys(this.formData).forEach(item => {
                    this.formData[item] = newVal[item]
                })
                this.type2Init(newVal.type1)
                this.type3Init(newVal.type2)
            },
            deep: true
        }
    },
    created() {
        this.typeInit()
    },
    methods: {
        /**
         * @description: 过滤非数字和非字母
         * @param {*}
         * @return {*}
         */
        inputChange(e) {
            var reg = /[\u4e00-\u9fa5]/g;
            this.formData.code = e.replace(reg, '');
        },
        /**
         * @description: 关闭弹窗清除数据
         * @param {*}
         * @return {*}
         */
        closeModule() {
            this.formData = this.$options.data().formData;
            this.$emit('upDatas')
        },

        /**
         * @description: 根据一级初始化获取二级
         * @param {*}
         * @return {*}
         */
        type2Init(event) {
            list({
                ...this.listQuery,
                parentId: event
            }).then(res => {
                if (res.code == 0) {
                    this.type2List = res.data
                }
            })
        },

        /**
         * @description: 根据二级初始化获取三级
         * @param {*}
         * @return {*}
         */
        type3Init(event) {
            list({
                ...this.listQuery,
                parentId: event
            }).then(res => {
                if (res.code == 0) {
                    this.type3List = res.data
                }
            })
        },

        /**
         * @description: 根据一级选中id获取二级数据
         * @param {*}
         * @return {*}
         */
        type1Change(event) {
            this.type2List = [];
            this.formData.type2 = '';
            this.type3List = [];
            this.formData.type3 = '';
            list({
                ...this.listQuery,
                parentId: event
            }).then(res => {
                if (res.code == 0) {
                    this.type2List = res.data
                }
            })
        },

        /**
         * @description: 根据二级选中id获取三级数据
         * @param {*}
         * @return {*}
         */
        type2Change(event) {
            this.type3List = [];
            this.formData.type3 = '';
            list({
                ...this.listQuery,
                parentId: event
            }).then(res => {
                if (res.code == 0) {
                    this.type3List = res.data
                }
            })
        },

        /**
         * @description: 一级分类，二级分类，三级分类
         * @param {*}
         * @return {*}
         */
        typeInit() {
            list(this.listQuery).then(res => {
                if (res.code == 0) {
                    this.type1List = res.data
                }
            })
        },

        /**
         * @description: 重置
         * @param {*}
         * @return {*}
         */
        resetHandel() {
            let id = this.formData.id;
            this.formData = this.$options.data().formData;
            this.formData.enabled = true;
            this.formData.id = id;
            this.type2List = []
            this.type3List = []
        },
        /**
         * @description: 提交
         * @param {*}
         * @return {*}
         */
        onSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    //TODO 修改
                    if (this.isEdit) {
                        putTreatment(this.formData).then(res => {
                            if (res.code == 0) {
                                this.$message.success('修改成功');
                                this.dialogVisible = false;
                                this.formData = this.$options.data().formData;
                                this.$emit('upadate')
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    } else {
                        //TODO新增
                        addTreatment(this.formData).then(res => {
                            if (res.code == 0) {
                                this.$message.success('添加成功');
                                this.dialogVisible = false;
                                this.formData = this.$options.data().formData;
                                this.$emit('upadate')
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }
                }
            });
        },
        /**
         * @description:  编辑打开弹窗
         * @param {*}
         * @return {*}
        */
        editProject(row) {
            this.title = '编辑治疗项目';
            this.isEdit = true;
            this.dialogVisible = true
        },
        /**
         * @description:  新增打开弹窗
         * @param {*}
         * @return {*}
        */
        openDialog() {
            this.title = '新增治疗项目';
            // this.type1List = []
            this.type2List = []
            this.type3List = []
            this.isEdit = false;
            this.formData.enabled = true
            this.dialogVisible = true
        },

    },
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__title {
    font-weight: 26px;
    color: #333;
    font-weight: bold;
}

/deep/ .el-form-item {
    // margin-bottom: 30px;
    .el-input,
    .el-textarea {
        width: 360px;

        .el-textarea__inner {
            height: 150px;
        }
    }

    // .el-textarea{
    //     height: 150px;
    // }
}
</style>
